export default class MassiaSelectService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}
}
